@import '../../../globals/main.scss';

pn-product-tile-price {
  margin-top: 1em;
  white-space: nowrap;
  text-align: right;
  span {
    font-size: 3em;
    font-size: clamp(2em, 6vw, 3em);
  }
  span:last-child {
    display: inline-block;
    margin-left: 0.2em;
  }
  & + pn-product-tile-price {
    margin-left: 1.5em;
  }

  pn-icon {
    display: inline-block;
    align-self: center;
  }

  a {
    text-decoration: none;
    color: $blue700;
    h3 {
      text-decoration: underline;
    }
  }
}
